const AvaluacioColors = {
    colors: {
        color1: '#0c2b48',
        color2: '#173f65',
        color3: '#205481',
        color4: '#4981b6',
        color5: '#6796c5',
        color6: '#93b6d3',
    },
}

export default AvaluacioColors;
